// Configuration for Report Configuration API
// Set USE_LOCAL_API to true when developing with local backend
const USE_LOCAL_API = false;
const LOCAL_API_URL = 'http://localhost:4004';

/**
 * Get the base URL for Report Configuration API
 * - If USE_LOCAL_API is true: uses LOCAL_API_URL
 * - Otherwise: uses VITE_BASEURL from environment
 * - Falls back to localhost:4004 if no env is set
 */
const getBaseUrl = (): string => {
  if (USE_LOCAL_API) {
    return LOCAL_API_URL;
  }
  
  return import.meta.env.VITE_BASEURL || 'http://localhost:4004';
};

export const REPORT_CONFIG_BASE_URL = getBaseUrl();

/**
 * Get the API path prefix
 * - Local: no prefix (direct endpoints)
 * - Deployed: /report-config prefix
 */
const getApiPrefix = (): string => {
  return USE_LOCAL_API ? '' : '/report-config';
};

const API_PREFIX = getApiPrefix();

export const API_ENDPOINTS = {
  ALLOWABLE_VALUES: `${API_PREFIX}/v1/report-configuration/allowable-values`,
  BRAND_PLATFORMS: (brandId: number) => `${API_PREFIX}/v1/report-configuration/brand/${brandId}/platforms`,
  VALIDATE_SELECTION: `${API_PREFIX}/v1/report-configuration/allowable-values/validate`,
  CONFIGURATIONS: `${API_PREFIX}/v1/report-configuration`,
  CONFIGURATION_BY_ID: (id: number) => `${API_PREFIX}/v1/report-configuration/${id}`,
  CONFIGURATION_BY_BRAND: (brandId: number) => `${API_PREFIX}/v1/report-configuration/brand/${brandId}`,
  DEACTIVATE: (id: number) => `${API_PREFIX}/v1/report-configuration/${id}/deactivate`,
  ACTIVATE: (id: number) => `${API_PREFIX}/v1/report-configuration/${id}/activate`,
} as const;
